/**
 * A video the client sends in the concierge chat: evidence of the transfer for the operator, never a
 * receipt. The BFF and the backend use the same list; the backend decides by content in the end.
 */
export const MAX_CONCIERGE_VIDEO_SIZE = 100 * 1024 * 1024; // 100 MB

export const VIDEO_EXTS = ['mp4', 'mov', 'm4v', 'webm', '3gp', '3gpp', 'mkv', 'avi'];

const extOf = (name: string): string => {
  const clean = name.split(/[?#]/)[0];
  const dot = clean.lastIndexOf('.');
  return dot < 0 ? '' : clean.slice(dot + 1).toLowerCase();
};

/** By the name (or a URL) alone — what the feed has for a Verbox attachment. */
export const isVideoName = (name: string): boolean => VIDEO_EXTS.includes(extOf(name));

/** The containers the BFF can tell by content; another `video/*` would only be refused there. */
export const VIDEO_MIMES = ['video/mp4', 'video/quicktime', 'video/x-m4v', 'video/webm', 'video/3gpp', 'video/3gpp2', 'video/x-matroska', 'video/x-msvideo', 'video/avi'];

/**
 * By type; by extension when the type is not a video one at all — an Android cloud pick often has
 * none, a browser may say `application/mp4`. A video type the BFF cannot tell apart stays refused.
 */
export const isVideoFile = (file: File): boolean =>
  VIDEO_MIMES.includes(file.type) || (!file.type.startsWith('video/') && isVideoName(file.name));
